'use strict';

angular.module('integrationModule')

.factory('integrationViewOptions', function (extendDeep, resourceViewOptions, listView)
{
    var options = angular.copy(resourceViewOptions);

    extendDeep(options, {
        list: {
            columns: [
                {
                    label: 'Key',
                    name: 'key',
                    sortable: true
                },
                {
                    label: 'Asset',
                    name: 'asset.name',
                    sortable: false
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    sortable: true,
                    template: '<span class="resource-ui-lastmodified">{{ model.updated_at | date }}</span>'
                }
            ]
        },
        views: [listView]
    });

    return options;
});
